<template>
  <div id="create-collector" class="d-flex justify-center align-center fill-height">
    <div>
        <v-card class="add-edit-wrapper ma-auto" width="650">
          <div class="close-btn">
            <i class="material-icons white--text" @click="$router.push('/utilities')">
              clear
            </i>
          </div>
          <v-toolbar color="primary" dark class="shadow-none">
            <v-card-title class="headline px-0">
              {{ editMode }} Collector
            </v-card-title>
          </v-toolbar>
          <v-container grid-list-xl fluid :class="[collector && collector.drives.length ? 'pb-0' : '']" >
            <v-layout row wrap>
              <v-flex xs12 md12 class="pa-0">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                  <v-text-field label="Name"
                    class="select-field"
                    clearable
                    v-model="name"
                    :rules="[v => (v || '').length > 0 || 'Name is required']"
                    v-on:keyup.enter="saveCollector()"
                  >
                  </v-text-field>
                  <v-select
                    v-if="enableProcessingCluster"
                    label="Processing Clusters"
                    v-model="selectedProcessingCluster"
                    :items="clustersItems"
                    item-text="name"
                    item-value="entity_id"
                    flat
                    hide-details
                    clearable
                    :menu-props="{ offsetY: true }"
                    :disabled="loading"
                  >
                  <template v-if="selectedProcessingCluster" v-slot:append-outer>
                    <v-tooltip :key="collector.cluster_status" bottom v-if="collector.cluster_id && isClusterReachable === false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="error" v-on="on" v-bind="attrs">mdi-alert-circle</v-icon>
                      </template>
                      <div class="text-center">
                        <span>{{ (collector.cluster_status.error || "There was an error reaching the cluster on " + collector.cluster_status.address) }}</span>
                        <br />
                        <span><b>Save the collector again to retry.</b></span>
                      </div>
                    </v-tooltip>
                    <v-tooltip :key="collector.cluster_status" bottom v-else-if="collector.cluster_id && isClusterReachable === true">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="green" v-on="on" v-bind="attrs">mdi-check-circle</v-icon>
                      </template>
                      <div class="text-center">
                        <span>Connected</span>
                      </div>
                    </v-tooltip>
                    <v-tooltip :key="collector.cluster_status" bottom v-else-if="collector.cluster_id && collector.cluster_status == null">
                      <template v-slot:activator="{ on, attrs }">
                        <v-progress-circular :size="24" v-on="on" v-bind="attrs" indeterminate></v-progress-circular>
                      </template>
                      <div class="text-center">
                        <span>Trying to establish connection to processing cluster...</span>
                      </div>
                    </v-tooltip>
                  </template>
                  </v-select>
                </v-form>
              </v-flex>
            </v-layout>
            <template v-if="collector.collector_type == 'on-prem'">
              <v-layout class="pb-1">
                <div class="custorm-drives">Custom Drive Names</div>
              </v-layout>
              <v-layout row class="d-flex justify-space-between align-center">
                <v-flex xs12 md4 class="pa-0">
                  <v-select
                    label="Select Drive"
                    ref="customDrive"
                    v-if="collectorDrives.length"
                    v-model="selectedDrive"
                    :items="collectorDrives"
                    flat
                    outlined
                    hide-details
                    :menu-props="{ offsetY: true }"
                    :disabled="loading"
                    @change="setCustomFieldFocus"
                  >
                    <template slot="selection" slot-scope="data">
                      <strong>{{ data.item}}</strong>
                    </template>
                    <template slot="item" slot-scope="data">
                      <span style="color: black">
                        {{ data.item}}
                      </span>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md6 class="pa-0">
                  <v-text-field
                    v-show="selectedDrive"
                    ref="customNameField"
                    label="Custom Name"
                    class="select-field"
                    hide-details
                    outlined
                    autoFocus
                    v-model="customName"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md1 class="pa-0">
                  <div v-show="customName">
                    <v-icon
                      class="material-icons-outlined clickable"
                      size="30px"
                      @click="addCustomDrive"
                    >
                      mdi-check-circle-outline
                    </v-icon>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout class="pt-3">
                <v-flex xs12 md4 class="pa-0">
                  <strong class="">Drive Name</strong>
                </v-flex>
                <v-flex xs12 md4 class="pa-0">
                  <strong>Custom Name</strong>
                </v-flex>
              </v-layout>
            </template>
          </v-container>
          <div v-if="collector.collector_type == 'on-prem'" class="drives-container">
            <v-layout
              v-for="(drive, index) in Object.keys(customDrivesName)"
              :key="index"
              class="d-flex flex-row align-center"
            >
              <v-flex xs12 md4 class="pa-0"><div class="custorm-drives-name"> {{drive}}</div></v-flex>
              <v-flex xs12 md4 class="pa-0"><div class="custorm-drives-name ml-3">{{customDrivesName[drive] || drive}}</div></v-flex>
              <v-flex xs12 md4 class="pa-0 text-right">
                <v-icon
                  class="material-icons-outlined clickable"
                  @click="editCustomName(drive)"
                >
                  edit
                </v-icon>
                <v-icon
                  class="material-icons-outlined clickable"
                  @click="deleteCustomName(drive)"
                >
                  delete
                </v-icon>
              </v-flex>
            </v-layout>
          </div>
          <v-card-actions class="pa-0 pt-4">
            <v-spacer></v-spacer>
            <v-btn class="cancel-btn" text @click="$emit('resetEditDialog')">
              Cancel
            </v-btn>
            <v-btn class="save-btn" text @click="saveCollector()">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      <v-layout></v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CollectorEditor',
  props: ['id', 'editMode', 'clusterId'],
  data () {
    return {
      collector: null,
      name: '',
      valid: '',
      loading: false,
      selectedProcessingCluster: null,
      clustersItems: [],
      selectedDrive: '',
      customName: '',
      customDrivesName: {}
    }
  },
  created () {
    this.loadCollector()
  },
  mounted () {
    this.customDrivesName = this.collector.drivesName ? this.collector.drivesName : {}
    this.selectedProcessingCluster = this.clusterId
    this.setClusterItems()
  },
  computed: {
    ...mapGetters(['collectors', 'license', 'currentOrganization', 'processingClusters']),
    enableProcessingCluster () {
      return this.license && this.license.enable_processing_cluster && this.license.enable_processing_cluster == true
    },
    collectorDrives () {
      return this.collector.drives.filter(drive => !this.customDrivesName[drive])
    },
    isClusterReachable () {
      return (this.collector.cluster_status || {}).reachable
    }
  },
  methods: {
    deleteCustomName (drive) {
      delete this.customDrivesName[drive]
      this.customDrivesName = { ...this.customDrivesName }
    },
    editCustomName (drive) {
      this.selectedDrive = drive
      this.customName = this.customDrivesName[drive]
      delete this.customDrivesName[drive]
      this.customDrivesName = { ...this.customDrivesName }
    },
    addCustomDrive () {
      if (this.customName) {
        this.customDrivesName[this.selectedDrive] = this.customName
        this.customDrivesName = { ...this.customDrivesName }
        this.selectedDrive = ''
        this.customName = ''
      }
    },
    setCustomFieldFocus () {
      this.$nextTick(() => {
        this.$refs.customNameField.focus()
        this.$refs.customDrive.blur()
      })
    },
    loadCollector () {
      const collector = this.collectors.find(item => item.entity_id === this.id)
      if (!collector) {
        this.$router.push('/utilities')
      } else {
        if (!this.collector || this.collector.name !== collector.name) {
          this.name = collector.name
        }
        this.collector = collector
      }
    },
    saveCollector () {
      this.$refs.form.validate()
      if (!this.valid) return
      this.collector.name = this.name
      this.collector.drivesName = this.customDrivesName
      this.collector.cluster_id = this.selectedProcessingCluster
      if (this.selectedProcessingCluster) {
        this.sendVerifyConnectionCommand(this.selectedProcessingCluster)
      }
      this.collector.cluster_status = null
      this.$store.dispatch('saveCollector', this.collector)
      this.$emit('resetEditDialog')
      // this.$router.push('/utilities')
    },
    buildClusterUrl (cluster_obj) {
      const cluster_ip = cluster_obj.local_ip
      const ssl_supported = cluster_obj.ssl_supported
      const ssl_domain = cluster_obj.ssl_domain

      if (ssl_supported && ssl_domain) {
        const custom_port = cluster_obj.custom_port ? `:${cluster_obj.custom_port}` : ''
        return `https://${ssl_domain}${custom_port}`
      } else if (cluster_ip) {
        return `http://${cluster_ip}:8000`
      }
    },
    sendVerifyConnectionCommand (clusterId) {
      const clusterObj = this.processingClusters.filter(cluster => cluster.entity_id === clusterId)[0]
      const clusterUrl = this.buildClusterUrl(clusterObj)
      const command = {
        type: 'VERIFY_CLUSTER_CONNECTION',
        data: [{
          key: 'address',
          value: clusterUrl
        }],
        organization_id: this.currentOrganization.entity_id,
        collector_id: this.collector.entity_id,
        status: 'pending'
      }

      this.$store.dispatch('postCommand', command)
    },
    setClusterItems () {
      if (this.currentOrganization.partner == 'msp_client' && this.processingClusters.length) {
        this.clustersItems = [this.processingClusters[0]]
        this.selectedProcessingCluster = this.processingClusters[0]
      } else {
        this.clustersItems = this.processingClusters
      }
    }
  },
  watch: {
    collectors () {
      this.loadCollector()
    },
    processingClusters () {
      this.setClusterItems()
    }
  }
}
</script>

<style scoped lang="scss">

  .v-input.v-select {
    align-items: center;
  }

  .logo-display {
    border-radius: 10px;
  }

  .logo-message {
    font-size: 12px;
    color: grey;
    margin-top: 5px;
    margin-bottom: 10px;
    text-align: center;
  }

  .centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }

  .faded {
    opacity: 0.5;
  }

  .clickable {
    cursor: pointer;
  }

  .not-clickable {
    cursor: not-allowed;
  }

  .custorm-drives {
    font-weight: bold;
    padding-top: 10px;
  }
  .custorm-drives-name {
    /* font-weight: bold; */
    font-size: 16px;
  }
  .drives-container {
    max-height: 140px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 0px;
  }
</style>
